import { Directive } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';
import {
  getErrorMessages,
  getValidityClass,
  mergeControlWithFormErrors,
} from './password-form.utils';
import {
  AUTHENTICATION_ERROR_MESSAGES,
  PASSWORD_ERROR_MESSAGES,
} from '@epicuro-next/constants/features/localization';

@Directive()
export abstract class BasePasswordFormComponent {
  /**
   * Each subclass must implement its own form instance
   */
  public abstract passwordForm: FormGroup;

  /**
   * Each subclass can optionally specify "specific" field errors
   * e.g. 'passwordsDontMatch', 'passwordsSame' etc.
   */
  public abstract fieldErrorMap: Record<string, string[]>;

  /**
   * Returns merged control errors for a given formControlName
   */
  public getInputErrors(formControlName: string): ValidationErrors | null {
    const control = this.passwordForm.get(formControlName);
    if (!control) return null;
    // Merge with form-level errors that are relevant to this field
    return mergeControlWithFormErrors(
      control,
      this.passwordForm.errors,
      this.fieldErrorMap[formControlName] || [],
    );
  }

  /**
   * Returns a CSS class for control validity
   */
  public getValidityClass(formControlName: string): string | null {
    const control = this.passwordForm.get(formControlName);
    const errors = this.getInputErrors(formControlName);
    return getValidityClass(control, errors);
  }

  /**
   * Returns an array of user-friendly error messages
   */
  public getAuthenticationError(error: string): string {
    return AUTHENTICATION_ERROR_MESSAGES[error] ?? error;
  }

  /**
   * Returns an array of user-friendly error messages
   */
  public getInputErrorMessages(formControlName: string): string[] {
    const errors = this.getInputErrors(formControlName);
    return getErrorMessages(errors, PASSWORD_ERROR_MESSAGES);
  }
}
